import { z } from "zod";


// ContratoInformacoesSchema

const optionalNumber = z.coerce.number().int();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalDate = z.coerce.date();

export const ContratoInformacoesSchema = z.object({
  IdContratoInformacoes: z.number().int().default(0),
  IdContrato: optionalNumber,
  DescInformacoes: optionalString,
  IdFuncionario: optionalNumber,
  Data: optionalDate,
});

// ContratoInformacoesForm
export type ContratoInformacoesForm = z.infer<typeof ContratoInformacoesSchema>;